webpackJsonp([23899280101116],{

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/centurylink.75144b0a.jpg";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/colleen-takagishi.c5f63653.jpg";

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fulenwider.96e2908b.jpg";

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gutcheck.6d221d6d.jpg";

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/henry-county.bf669bbf.jpg";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/parker.d38f442a.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/weeschool.c2f5b6fd.jpg";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _workModule = __webpack_require__(300);
	
	var _workModule2 = _interopRequireDefault(_workModule);
	
	var _weeschool = __webpack_require__(461);
	
	var _weeschool2 = _interopRequireDefault(_weeschool);
	
	var _henryCounty = __webpack_require__(458);
	
	var _henryCounty2 = _interopRequireDefault(_henryCounty);
	
	var _gutcheck = __webpack_require__(456);
	
	var _gutcheck2 = _interopRequireDefault(_gutcheck);
	
	var _centurylink = __webpack_require__(450);
	
	var _centurylink2 = _interopRequireDefault(_centurylink);
	
	var _colleenTakagishi = __webpack_require__(452);
	
	var _colleenTakagishi2 = _interopRequireDefault(_colleenTakagishi);
	
	var _parker = __webpack_require__(459);
	
	var _parker2 = _interopRequireDefault(_parker);
	
	var _fulenwider = __webpack_require__(454);
	
	var _fulenwider2 = _interopRequireDefault(_fulenwider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var portfolio = {
	  "items": [{
	    "name": "WeeSchool",
	    "image": '' + _weeschool2.default,
	    "type": ["development"],
	    "url": "https://weeschool.com",
	    "description": "Wordpress site for a premium iOS app for new parents.",
	    "bulletPoints": ["custom wordpress theme", "custom wordpress plugins", "html", "css / sass", "javascript"]
	  }, {
	    "name": "Henry County Development Authority",
	    "image": '' + _henryCounty2.default,
	    "type": ["development"],
	    "url": "http://www.choosehenry.com",
	    "description": "A feature-rich site for an economic development group in the Atlanta area built on Kentico CMS. The site offers extensive information on development opportunities and available properties. Built with multiple templates that feature embedded Google Maps and editable content carousels.",
	    "bulletPoints": ["html", "css / sass", "bootstrap", "javascript / jquery"]
	  }, {
	    "name": "GutCheck",
	    "image": '' + _gutcheck2.default,
	    "type": ["design", "development"],
	    "url": "https://gutcheckit.com",
	    "description": "Corporate site and blog built on WordPress for a market research company in Denver. The site provides information about the company, their product offerings, as well as contact forms and live chat. The blog and resources sections are carefully curated collections of tips and insights for the market research industry.",
	    "bulletPoints": ["design", "custom wordpress theme", "html", "css / sass", "javascript / jquery"]
	  }, {
	    "name": "CenturyLink: My Account",
	    "image": '' + _centurylink2.default,
	    "type": ["development"],
	    "url": "https://eam.centurylink.com/eam/login.do",
	    "description": "Customer account portal for a telecom company. This site is where customers come to look up account information, pay bills, and manage their services.",
	    "bulletPoints": ["revamped old site to be mobile responsive", "bootstrap", "html", "css", "javascript"]
	  }, {
	    "name": "Colleen Takagishi RD",
	    "image": '' + _colleenTakagishi2.default,
	    "type": ["design", "development"],
	    "url": "http://eatwell.me",
	    "description": "A simple business site for a dietitian built on WordPress. The site provides a list of frequently asked questions, rates, directions to the business, as well as information about what to expect when visiting.",
	    "bulletPoints": ["design", "custom wordpress theme", "html", "css"]
	  }, {
	    "name": "Parker, CO Economic Develpment Department",
	    "image": '' + _parker2.default,
	    "type": ["development"],
	    "url": "http://parkered.org",
	    "description": "A feature-rich site for an economic development group in the Denver area built on Kentico CMS. The site offers extensive information on development opportunities and available properties. Built with multiple templates that feature embedded Google Maps and editable content carousels.",
	    "bulletPoints": ["html", "css / sass", "bootstrap", "javascript / jquery"]
	  }, {
	    "name": "LC Fulenwider: Pena Station",
	    "image": '' + _fulenwider2.default,
	    "type": ["development"],
	    "url": "https://penastationnext.com",
	    "description": "Online presence for an economic development site in the Denver area built on Kentico CMS. The website features a hero-style content carousel on the home page and easy to update staff contact information as well as an embedded Google Map.",
	    "bulletPoints": ["html", "css / sass", "bootstrap", "javascript / jquery"]
	  }]
	};
	
	var WorkPage = function WorkPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Work'
	    ),
	    portfolio.items.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { className: _workModule2.default.portfolioItem, key: item.name },
	        _react2.default.createElement(
	          'h3',
	          { className: _workModule2.default.name },
	          item.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _workModule2.default.url },
	          _react2.default.createElement(
	            'a',
	            { href: item.url },
	            item.url
	          )
	        ),
	        item.type.map(function (type) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: type,
	              className: _workModule2.default.type
	            },
	            type
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _workModule2.default.content },
	          _react2.default.createElement(
	            'div',
	            { className: _workModule2.default.copy },
	            _react2.default.createElement(
	              'div',
	              null,
	              item.description
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: _workModule2.default.bulletPoints },
	              item.bulletPoints.map(function (point) {
	                return _react2.default.createElement(
	                  'li',
	                  {
	                    key: point,
	                    className: _workModule2.default.bulletPoint
	                  },
	                  point
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _workModule2.default.image },
	            _react2.default.createElement('img', { src: item.image, alt: item.name })
	          )
	        )
	      );
	    })
	  );
	};
	
	exports.default = WorkPage;
	module.exports = exports['default'];

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"portfolioItem":"src-pages----work-module---portfolioItem---2Wn8K","name":"src-pages----work-module---name---39eRk","content":"src-pages----work-module---content---1Uoje","image":"src-pages----work-module---image---30Xwy","copy":"src-pages----work-module---copy---1ob32","type":"src-pages----work-module---type---4Kv3m","url":"src-pages----work-module---url---12Jux","bulletPoints":"src-pages----work-module---bulletPoints---1pVoG","bulletPoint":"src-pages----work-module---bulletPoint---3cWE1"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-work-js-cf6967af36a83859b677.js